import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderRight from "./HeaderRight";

import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import storage from "../services/Storage";
import { setToken } from "../store/auth/authState";
import { setUser } from "../store/auth/user";
import { useDispatch, useSelector } from "react-redux";
import OTPInput from "otp-input-react";
import { SpinnerCircular } from "spinners-react";

export default function OTPverification(props) {
  const craditional = useSelector((state) => state.login.craditional);

  const dispatch = useDispatch();
  const [OTP, setOTP] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendCode, setresendCode] = useState("");

  const navigate = useNavigate();

  const ResendCode = () => {
    http.post(`public/admin/auth`, craditional).then((res) => {
      console.log("response==>", res.data);
      setresendCode(res.data.token);
      showToast("success", "code has been sent");
    });
  };

  useEffect(() => {
    const token = GetStorage.get("xAuthToken");
    setresendCode(token);
  }, []);

  const handleSubmit = async (otp) => {
    setLoading(true);
    http
      .post(`public/verify`, {
        code: otp,
        token: resendCode,
      })
      .then((res) => {
        console.log("otp response ------->>>>", res.data);
        setLoading(false);

        const { data } = res;
        const { token, token1 } = data;
        let user = data;

        dispatch(setToken(token));
        dispatch(setUser(data));

        storage.store("xAuthToken", token);
        storage.store("xAuth", token1);
        storage.store("user", user);
        navigate("/adminDashBord");
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
          }
        }
      });
  };

  useEffect(() => {
    if (OTP.length === 6) {
      handleSubmit(OTP);
    }
  }, [OTP]);

  return (
    <>
      <HeaderRight />
      <section className="otp_verification custom_hight">
        <div className="login_inner  pt-0">
          <h1 className="mb_30 main_title ">OTP Verification </h1>
          <p className="mb_40 them_para text-center mx-auto">
            We have sent a 6 digit OTP to your email
            <br />
            Please enter the OTP to continue
          </p>

          <div className="otp_wraper">
            <OTPInput
              value={OTP}
              onChange={setOTP}
              autoFocus
              OTPLength={6}
              otpType="number"
              inputStyle={{
                width: 300,
                height: 200,
              }}
              inputStyles={{ width: 60, height: 60 }}
              inputClassName="otp_input"
            />
          </div>
          {loading && (
            <div className="spinner_wraper">
              <SpinnerCircular style={{ height: 40, marginTop: 7 }} />
            </div>
          )}

          <div className="otp-resend">
            <p className="opt-receive-code">Didn't Receive Code?</p>
            <p className="otp-btn-link" onClick={ResendCode}>
              {" "}
              Resend Code
            </p>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
